import { CurrentReservationService } from '@/common/services/reservation/current';
import { FindLocationsUseCase } from '@/core/domain/locations/usecases/findLocations.usecase';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
    selector: 'fe-office-search',
    templateUrl: './office-search.component.html',
    styleUrls: ['./office-search.component.scss'],
})
export class OfficeSearchComponent {
    public reservation$!: Observable<any>;

    public loadingLocations = false;

    public textNotFoundLocations: string | null = null;

    constructor(
        public reservation: CurrentReservationService,
        private readonly findLocationsUseCase: FindLocationsUseCase,
        private readonly router: Router,
    ) {}

    public onSearchLocations(term: string): void {
        this.loadingLocations = true;
        this.findLocationsUseCase
            .execute({ searchTerm: term })
            .subscribe((locations) => {
                this.loadingLocations = false;
                this.reservation.locations = (
                    locations.data as {
                        [key: string]: unknown;
                    }[]
                ).filter((location) => location['location'] !== 'INT');
                this.checkTextLabelLocations(term);
            });
    }

    private checkTextLabelLocations(term: string): void {
        this.textNotFoundLocations =
            term.length >= 3 && this.reservation.locations.length === 0
                ? 'No se han obtenido resultados'
                : null;
    }

    public onLocationChange(selectedLocation: string[]): void {
        if (selectedLocation[0]) {
            this.router.navigate([
                `/es/destino-aeropuerto/${selectedLocation[0]}`,
            ]);
        }
    }
}
